import { render, staticRenderFns } from "./edit-generic-zero-brand.modal.vue?vue&type=template&id=38273747&scoped=true&"
import script from "./edit-generic-zero-brand.modal.vue?vue&type=script&lang=js&"
export * from "./edit-generic-zero-brand.modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-generic-zero-brand.modal.vue?vue&type=style&index=0&id=38273747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38273747",
  null
  
)

export default component.exports